import React from 'react';
import { CapaQuotationPartnerEquipment } from '@generated/graphql';
import DetailViewDialog from '../DetailViewDialog';
import ListItem from './ListItem';

const EquipmentDetailInformation: React.FunctionComponent<{
  equipment: CapaQuotationPartnerEquipment;
}> = ({ equipment }) => {
  const noFile = !equipment.file;

  return (
    <DetailViewDialog.Informaiton
      projectName={equipment.equipmentName}
      description={equipment.description ?? undefined}
      paddingTop={noFile ? 48 : undefined}
      content={
        <ListItem
          label="보유대수"
          value={
            equipment.quantity
              ? `${equipment.quantity.toLocaleString('kr')}대 보유 중`
              : undefined
          }
        />
      }
    />
  );
};

export default EquipmentDetailInformation;
